import { isEmpty } from 'lodash';
import { unFormatPercent, toFixed } from 'utils';

export const portfolioBuilder = (val: any) => {
  if (isEmpty(val)) return {};
  const errors: any = {};

  const { fund_allocations } = val;
  const areAllocations = fund_allocations.length > 0;

  const allocationsSum = fund_allocations.reduce(
    (fundA: any, fundB: any) => {
      const allocationA = unFormatPercent(fundA.allocation);

      const allocationB = unFormatPercent(fundB.allocation);

      return {
        allocation: toFixed(allocationA) + toFixed(allocationB)
      };
    },
    { allocation: 0 }
  );

  // TODO TEMPORARY HOT FIX UNTILL BACKEND RESOLVE ROUNDING ISSUE
  const validAllocation = [100, 99.99, 100.01];
  if (areAllocations && !validAllocation.includes(allocationsSum.allocation)) {
    errors.fund_error = 'Recommended weighting are not add up to 100%';
  }

  return errors;
};
